import React, { Component } from 'react';

import 'components/landlord_app/tenants/components/LandlordTenantsPage.css';
import 'react-table/react-table.css';

import { connect } from 'react-redux';
import ReactTable from 'react-table';
import moment from 'moment';
import capitalize from 'capitalize';

import TextField from 'material-ui/TextField';
import MenuItem from 'material-ui/MenuItem';
import Toggle from 'material-ui/Toggle';
import FlatButton from 'material-ui/FlatButton';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import * as landlordAPIDashboardActions from 'actions/landlordAPIDashboardActions';

import { startsWith } from 'helpers/StringHelper';
import { AccentColor } from 'helpers/AccentColorHelper';

import * as ByesignHelper from 'components/byesign/ByesignHelper';
import OptionsDropdown from 'components/shared/OptionsDropdown';
import Dashboard from 'components/shared/Dashboard';
import DocumentStatus from 'components/shared/DocumentStatus';
import DocumentInformation from './DocumentInformation';

let documentsTable = connect(store => {
  return {
    documents: store.landlordAPIDashboard.documents,
    statistics: store.landlordAPIDashboard.statistics,
  };
}, landlordAPIDashboardActions)(
  class DocumentsTable extends Component {
    constructor(props) {
      super(props);

      const tableSize = props.documents && props.documents.length > 0 ? props.documents.length : 4;
      this.state = {
        tableSize,
        mode: 'production',
        toggleLabel: 'Show Test Documents',
        data: props.documents,
        filterText: '',
        showDocumentDialog: false,
        showCancelDialog: false,
      };
    }

    UNSAFE_componentWillMount() {
      this.props.clearDocuments();
      this.props.getDocuments(this.state.mode);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      const tableSize =
        nextProps.documents && nextProps.documents.length > 0 ? nextProps.documents.length : 4;
      this.setState(
        {
          tableSize,
          data: nextProps.documents,
        },
        () => this.forceUpdate()
      );
    }

    getFilterText = e => {
      const text = e.target.value ? e.target.value : '';
      this.setState({ filterText: text });
    };

    updateFilter = (e, value) => {
      let mode = this.state.mode;
      let newMode = mode === 'production' ? 'test' : 'production';
      let newToggleLabel =
        newMode === 'production' ? 'Show Test Documents' : 'Showing Test Documents';

      this.setState({ mode: newMode });
      this.setState({ toggleLabel: newToggleLabel });
      this.props.getDocuments(newMode);
    };

    showCancelDialog = uuid => {
      this.setState({ showCancelDialog: true, uuidToCancel: uuid });
    };

    hideCancelDialog = () => {
      this.setState({ showCancelDialog: false, uuidToCancel: null });
    };

    showDocumentDialog = uuid => {
      this.setState({ showDocumentDialog: true, uuidToView: uuid });
    };

    hideDocumentDialog = () => {
      this.setState({ showDocumentDialog: false, uuidToView: null });
    };

    cancelDocument = () => {
      this.props.cancelDocument(this.state.mode, this.state.uuidToCancel);
      this.hideCancelDialog();
    };

    render() {
      const toggle = (
        <Toggle
          label={this.state.toggleLabel}
          labelPosition="right"
          style={{ marginTop: '10px' }}
          onToggle={this.updateFilter}
        />
      );

      const textFilter = this.state.filterText.toUpperCase();
      let filteredData;
      if (this.state.data) {
        filteredData = this.props.documents.filter(
          item =>
            (item.name && item.name.toUpperCase().includes(textFilter)) ||
            item.signers.some(signer => {
              return (
                signer.first_name.toUpperCase().includes(textFilter) ||
                signer.last_name.toUpperCase().includes(textFilter)
              );
            }) ||
            moment(item.created_at)
              .format('MMM D, YYYY h:mm:ss a')
              .toUpperCase()
              .includes(textFilter) ||
            moment(item.updated_at)
              .format('MMM D, YYYY h:mm:ss a')
              .toUpperCase()
              .includes(textFilter) ||
            item.status.toUpperCase().includes(textFilter) ||
            item.uuid.toUpperCase().includes(textFilter)
        );
      }
      const columns = [
        {
          header: 'UUID',
          headerClassName: 'headerColumn',
          accessor: 'uuid',
          width: 150,
          render: row => row.value,
        },
        {
          header: 'Name',
          headerClassName: 'headerColumn',
          width: 150,
          accessor: 'name',
        },
        {
          header: 'Created At',
          headerClassName: 'headerColumn',
          accessor: 'created_at',
          width: 190,
          render: row => moment(row.value).format('MMM D, YYYY h:mm:ss a'),
        },
        {
          header: 'Last Updated At',
          headerClassName: 'headerColumn',
          accessor: 'updated_at',
          width: 190,
          render: row => moment(row.value).format('MMM D, YYYY h:mm:ss a'),
        },
        {
          header: 'Status',
          headerClassName: 'headerColumn',
          accessor: 'status',
          width: 190,
          render: row => <DocumentStatus status={row.value} />,
        },
        {
          header: '',
          headerClassName: 'actions',
          render: row => (
            <div>
              <OptionsDropdown>
                {row.row.status !== ByesignHelper.status.DOCUMENT_COMPLETED &&
                  row.row.status !== ByesignHelper.status.DOCUMENT_CANCELLED &&
                  row.row.cancel_enabled && (
                    <MenuItem
                      primaryText="Cancel"
                      style={{ fontSize: '14px' }}
                      onClick={() => this.showCancelDialog(row.row.uuid)}
                    />
                  )}
                <MenuItem
                  primaryText="View Latest Document"
                  style={{ fontSize: '14px' }}
                  onClick={() => this.props.openDocument(this.state.mode, row.row.uuid)}
                />
                <MenuItem
                  primaryText="View Information"
                  style={{ fontSize: '14px' }}
                  onClick={() => this.showDocumentDialog(row.row.uuid)}
                />
              </OptionsDropdown>
            </div>
          ),
        },
      ];

      return (
        <div className="body" role="main">
          <div className="centers">
            <div className=" clearfix">
              <span className="page-title"> Documents ({capitalize(this.state.mode)}) </span>
              {this.props.statistics && (
                <Dashboard
                  data={[
                    { title: 'Total Documents', value: this.props.statistics.total },
                    {
                      title: 'Completed Documents',
                      value: this.props.statistics.completed_documents,
                    },
                    {
                      title: 'In-Progress Documents',
                      value:
                        this.props.statistics.total -
                        this.props.statistics.completed_documents -
                        this.props.statistics.cancelled_documents,
                    },
                    {
                      title: 'Cancelled Documents',
                      value: this.props.statistics.cancelled_documents,
                    },
                  ]}
                />
              )}

              <div className="row" style={{ marginTop: '-20px' }}>
                <TextField
                  hintText="Filter by document uuid, name and status "
                  style={{ fontSize: '13px' }}
                  value={this.state.filterText}
                  onChange={this.getFilterText}
                />
              </div>

              {toggle}

              <div style={{ marginBottom: '70px' }}>
                <ReactTable
                  data={filteredData}
                  columns={columns}
                  showFilters={false}
                  showPagination={false}
                  showPageSizeOptions={false}
                  pageSize={this.state.tableSize}
                  noDataText="No Documents"
                  defaultFilterMethod={(filter, row, column) => {
                    const id = filter.pivotId || filter.id;
                    return row[id] !== undefined
                      ? startsWith(String(row[id]).toLowerCase(), filter.value)
                      : true;
                  }}
                />
              </div>

              <Dialog
                disableBackdropClick
                fullScreen={this.props.fullScreen}
                open={this.state.showCancelDialog}
                onClose={this.hideCancelDialog}
                aria-labelledby="document-cancellation"
                classes={{
                  paper: 'form-dialog',
                }}
                style={{ zIndex: 3000 }}
              >
                <DialogTitle>
                  <h3 style={{ textAlign: 'center', margin: 0 }}>Document Cancellation</h3>
                </DialogTitle>
                <DialogContent style={{ textAlign: 'center', margin: 0 }}>
                  Are you sure you want to cancel the document?
                </DialogContent>
                <DialogActions style={{ display: 'block' }}>
                  <FlatButton
                    onClick={this.hideCancelDialog}
                    id="close-button"
                    style={{ color: AccentColor() }}
                  >
                    CLOSE
                  </FlatButton>
                  <FlatButton
                    variant="raised"
                    onClick={this.cancelDocument}
                    id="submit-button"
                    style={{
                      color: 'white',
                      backgroundColor: AccentColor(),
                    }}
                  >
                    YES
                  </FlatButton>
                </DialogActions>
              </Dialog>

              <Dialog
                disableBackdropClick
                fullScreen={this.props.fullScreen}
                open={this.state.showDocumentDialog}
                onClose={this.hideDocumentDialog}
                aria-labelledby="document-information"
                classes={{
                  paper: 'form-dialog',
                }}
                style={{ zIndex: 3000 }}
              >
                <DialogTitle>
                  <h3 style={{ textAlign: 'center', margin: 0 }}>Document Information</h3>
                </DialogTitle>

                <DialogContent>
                  <DocumentInformation mode={this.state.mode} uuid={this.state.uuidToView} />
                </DialogContent>

                <DialogActions style={{ display: 'block' }}>
                  <FlatButton
                    onClick={this.hideDocumentDialog}
                    id="close-button"
                    style={{ color: AccentColor() }}
                  >
                    CLOSE
                  </FlatButton>
                </DialogActions>
              </Dialog>
            </div>
          </div>
        </div>
      );
    }
  }
);

export default withMobileDialog()(documentsTable);
